import { createSvg } from '../createSvg';

const Edit2 = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'contour'}>
            <path
                d='M13.2601 3.59997L5.0501 12.29C4.7401 12.62 4.4401 13.27 4.3801 13.72L4.0101 16.96C3.8801 18.13 4.7201 18.93 5.8801 18.73L9.1001 18.18C9.5501
                 18.1 10.1801 17.77 10.4901 17.43L18.7001 8.73997C20.1201 7.23997 20.7601 5.52997 18.5501 3.43997C16.3501 1.36997 14.6801 2.09997 13.2601 3.59997Z'
                strokeWidth={strokeWidth}
                stroke='currentColor'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.8899 5.04993C12.3199 7.80993 14.5599 9.91993 17.3399 10.1999'
                strokeWidth={strokeWidth}
                stroke='currentColor'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3 22H21'
                strokeWidth={strokeWidth}
                stroke='currentColor'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Edit2,
    'edit-2',
);
